import { createFileRoute } from '@tanstack/react-router'

import type { LoggerId } from '@beaded/models'

import { loggerQueries } from 'lib/queries'

import Logger from 'pages/Logger'

export const Route = createFileRoute('/_auth/loggers/$id')({
  component: Logger,
  loader: ({ context: { queryClient }, params: { id } }) => {
    const loggerId = Number(id) as LoggerId
    if (isNaN(loggerId)) return

    void queryClient.prefetchQuery(loggerQueries.detail(loggerId))
  },
})
